class SecondaryMedia extends HTMLElement {
    constructor() {
        super();
        // Motion/Flickity are external scripts; if either fails to load, still show the images.
        if (window.Motion) {
            Motion.inView(this, () => { setTimeout(() => this.init()); }, { margin: "200px 0px 200px 0px" });
        } else {
            setTimeout(() => this.init());
        }
    }
    get template() {
        return this.previousElementSibling;
    }
    disconnectedCallback() {
        this.carousel && this.carousel.destroy();
    }
    init() {
        this.appendChild(this.template.content.cloneNode(!0)),
            (this.mediaCount = this.querySelectorAll(":scope > .media").length),
            (this.currentIndex = 0);
        if (this.mediaCount > 1 && !window.Flickity) {
            // Fallback: stack the images and crossfade to the next one on hover.
            this.classList.add("secondary-media--static");
            this.querySelectorAll("img").forEach((img) => (img.loading = "eager"));
            this.addEventListener("mouseenter", () => this.show(1));
            this.addEventListener("mouseleave", () => this.show(0));
            this.show(0);
            return;
        }
        this.mediaCount > 1 &&
                ((this.carousel = new Flickity(this, {
                    accessibility: !1,
                    draggable: !1,
                    pageDots: !0,
                    prevNextButtons: !1,
                    wrapAround: !0,
                    rightToLeft: false,
                    selectedAttraction: 0.2,
                    friction: 0.8,
                })),
                this.mediaCount === 2 && this.classList.add("without-dots"),
                this.addEventListener("mousemove", this.onMoveHandler.bind(this)),
                this.addEventListener("mouseleave", this.onLeaveHandler.bind(this)));
    }
    onMoveHandler(event) {
        const rect = this.getBoundingClientRect(),
            mouseX = event.clientX - rect.left,
            zoneWidth = rect.width / this.mediaCount,
            newIndex = Math.min(Math.floor(mouseX / zoneWidth), this.mediaCount - 1);

        if (newIndex !== this.currentIndex) {
            this.currentIndex = newIndex;
            this.show(newIndex);
        }
    }
    onLeaveHandler() {
        this.currentIndex = 0;
        this.show(0);
    }
    show(index) {
        if (this.carousel) return this.carousel.select(index, false, true); // true = instant jump, no wrap animation
        this.querySelectorAll(":scope > .media").forEach((media, i) => media.classList.toggle("is-active", i === index));
    }
}
customElements.define("secondary-media", SecondaryMedia);

document.addEventListener("DOMContentLoaded", () => {
  const heroSlider = document.querySelector(".customHeroSwiper");

  if (!heroSlider) return;

  new Swiper(heroSlider, {
    loop: true,
    speed: 1000,
    effect: "slide",
    // autoplay: {
    //   delay: 5000,
    //   disableOnInteraction: false,
    //   pauseOnMouseEnter: true,
    // },

    pagination: {
      el: ".custom-hero-slider .swiper-pagination",
      clickable: true,
    },

    navigation: {
      nextEl: ".custom-hero-slider .swiper-button-next",
      prevEl: ".custom-hero-slider .swiper-button-prev",
    },

    keyboard: {
      enabled: true,
    },

    a11y: {
      enabled: true,
    },

    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      750: {
        slidesPerView: 1,
      },
    },
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const animatedElements = document.querySelectorAll(".JS-scroll-animate");

  animatedElements.forEach((element) => {
    // Keep track of whether the element is visible on screen
    let isVisible = false;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        isVisible = entry.isIntersecting;
      });
    }, { threshold: 0 });

    observer.observe(element);

    window.addEventListener("scroll", function () {
      if (!isVisible) return; // Don't run calculations if off-screen

      // Get element position relative to the viewport
      const rect = element.getBoundingClientRect();
      const elementTop = rect.top + window.scrollY;
      const windowHeight = window.innerHeight;

      // Calculate how far through the viewport the element has scrolled (0 to 1)
      let progress = (window.scrollY + windowHeight - elementTop) / (windowHeight + rect.height);
      
      // Clamp the progress between 0 and 1 so it stops moving once out of view
      progress = Math.max(0, Math.min(1, progress));

      // CONTROL DISPLACEMENT HERE:
      // Change -50px (start position) and 50px (end position) to match how much total shift you want.
      const startX = -50; 
      const endX = 50;   
      const currentX = startX + (progress * (endX - startX));

      element.style.transform = `translateX(${currentX}px)`;
    });
  });
});